import { Helmet } from "react-helmet-async";

type MetaProps = {
  title: string;
  description: string;
  image?: string;
};

export default function Meta({ title, description, image }: MetaProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="apple-mobile-web-app-title" content={title}></meta>

      {/* Open Graph */}
      <meta property="og:site_name" content="株式会社リブゲートコーポレートサイト"/>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      {image && <meta property="twitter:image" content={image} />}

      {/* favicon */}
      <link rel="icon" href="https://lib-gate.co.jp/assets/images/favicon-Lib-150x150.png" sizes="32x32" />
      <link rel="icon" href="https://lib-gate.co.jp/assets/images//favicon-Lib.png" sizes="192x192" />
      <link rel="apple-touch-icon" href="https://lib-gate.co.jp/assets/images/favicon-Lib.png" />
      <meta name="msapplication-TileImage" content="https://lib-gate.co.jp/assets/images/favicon-Lib.png" />
    </Helmet>
  );
}
